<div class="modal-header text-center" style="border-bottom: none">

    <p>
      You already have a timer running for <strong>{{ company }}: {{ jobName }}</strong> 
      <br /> 
      Choose Continue below to stop that timer and start a new one - or Cancel to keep the existing timer running
    </p>
  </div>
  <div class="modal-footer">
    <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
      Cancel
    </div>
    <div
      class="btn btn-primary pull-right"
      aria-label="Confirm"
      (click)="confirm()"
    >
      Continue
    </div>
  </div>
  